import React from 'react';
import { Icon } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import Classes from './SellValueChecker.scss';

const CHECK_KEYS = ['check1', 'check2'] as const;

const SellValueChecker = () => {
  const { t } = useI18nContext();

  return (
    <section className={`PageContent-card PageContent-offset ${Classes.root}`}>
      <div className={Classes.inner}>
        <div className={Classes.left}>
          <h2 className={Classes.title}>{t('sell.page.value_checker.title')}</h2>
          <p className={Classes.subtitle}>{t('sell.page.value_checker.subtitle')}</p>
          <ul className={Classes.checklist}>
            {CHECK_KEYS.map((key) => (
              <li key={key} className={Classes.checkItem}>
                <div className={Classes.checkIcon}>
                  <Icon name="checkmark" color="action" />
                </div>
                <div>
                  <span className={Classes.checkLabel}>{t(`sell.page.value_checker.${key}.label`)}</span>
                  <p className={Classes.checkBody}>{t(`sell.page.value_checker.${key}.body`)}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className={Classes.right}>
          <p className={Classes.exampleLabel}>{t('sell.page.value_checker.example.label')}</p>
          <div className={Classes.exampleCard}>
            <div className={Classes.imagePlaceholder} aria-hidden="true" />
            <div className={Classes.exampleMeta}>
              <div>
                <p className={Classes.exampleCar}>{t('sell.page.value_checker.example.car')}</p>
                <p className={Classes.exampleYear}>{t('sell.page.value_checker.example.year')}</p>
              </div>
              <div className={Classes.examplePriceBlock}>
                <p className={Classes.exampleMarketValue}>{t('sell.page.value_checker.example.market_value')}</p>
                <p className={Classes.exampleMarketPrice}>{t('sell.page.value_checker.example.market_price')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SellValueChecker;
